export function sectorSliceHalfHeight(innerRadius, outerRadius, outerThickness = 0, radius = outerRadius, profile = 'tapered') {
    if (!Number.isFinite(outerThickness) || outerThickness < 0) {
        throw new Error('Sector-slice outer thickness must be finite and nonnegative.');
    }
    if (outerThickness === 0)
        return 0;
    if (!Number.isFinite(innerRadius) || !Number.isFinite(outerRadius) || innerRadius < 0 || outerRadius <= innerRadius) {
        throw new Error('Thick sector-slices require finite radii with outer radius greater than inner radius.');
    }
    if (profile === 'uniform')
        return outerThickness / 2;
    return outerThickness / 2 * Math.min(1, Math.max(0, (radius - innerRadius) / (outerRadius - innerRadius)));
}
export function resolveSectorSliceCompression(active, activeThicknessScale = 1, thicknessScale = 1) {
    if (!Number.isFinite(activeThicknessScale) || activeThicknessScale <= 0 || activeThicknessScale > 1) {
        throw new Error('Sector-slice active thickness scale must be greater than zero and at most one.');
    }
    if (!Number.isFinite(thicknessScale) || thicknessScale <= 0 || thicknessScale > 1) {
        throw new Error('Sector-slice thickness scale must be greater than zero and at most one.');
    }
    return (active ? activeThicknessScale : 1) * thicknessScale;
}
export function advanceSectorSliceCompression(current, target, deltaSeconds) {
    const next = target + (current - target) * Math.exp(-18 * Math.max(0, deltaSeconds));
    return Math.abs(next - target) < 0.001 ? target : next;
}
